/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Level_IntroInputs */

const en_guides_level_intro = /** @type {(inputs: Guides_Level_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introductory`)
};

const ko_guides_level_intro = /** @type {(inputs: Guides_Level_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입문`)
};

const ja_guides_level_intro = /** @type {(inputs: Guides_Level_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入門`)
};

/**
* | output |
* | --- |
* | "Introductory" |
*
* @param {Guides_Level_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_level_intro = /** @type {((inputs?: Guides_Level_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Level_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_level_intro(inputs)
	if (locale === "ko") return ko_guides_level_intro(inputs)
	return ja_guides_level_intro(inputs)
});